(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[62299,59654,55004,6050,12701,54223,59679],{

/***/ 59654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18422);






var Typography = function(props) {
    var _ref = (0,_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .useTypography */ .tj)(props), Tag = _ref.Tag, classes = _ref.classes, children = _ref.children, onClick = _ref.onClick, tabIndex = _ref.tabIndex, role = _ref.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, [
        "Tag",
        "classes",
        "children",
        "onClick",
        "tabIndex",
        "role"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest), {
        children: children
    }));
};
Typography.defaultProps = {
    variant: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
    size: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16
};
Typography.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),
    isBold: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    variant: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    mobileSize: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    tabIndex: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    role: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (Typography);


/***/ }),

/***/ 18422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tj": function() { return /* binding */ useTypography; },
/* harmony export */   "w1": function() { return /* binding */ TYPOGRAPHY_TAGS; },
/* harmony export */   "y3": function() { return /* binding */ TYPOGRAPHY_SIZE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2664);
/* harmony import */ var redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19341);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34461);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var TYPOGRAPHY_TAGS = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    p: "p",
    span: "span"
};
var TYPOGRAPHY_SIZE = {
    caption12: "caption",
    paragrapgh14: "paragrapgh-s",
    paragrapgh16: "paragrapgh-m",
    headline20: "headline-xs",
    headline24: "headline-s",
    headline38: "headline-m",
    headline46: "headline-l",
    headline56: "headline-xl"
};
var useTypography = function(_param) {
    var variant = _param.variant, isBold = _param.isBold, className = _param.className, children = _param.children, size = _param.size, mobileSize = _param.mobileSize, onClick = _param.onClick, tabIndex = _param.tabIndex, role = _param.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "variant",
        "isBold",
        "className",
        "children",
        "size",
        "mobileSize",
        "onClick",
        "tabIndex",
        "role"
    ]);
    var isDesktopResolution = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__.useSelector)(redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__/* .selectIsDesktop */ .Y6);
    var Tag = TYPOGRAPHY_TAGS[variant] || variant;
    var actualSize = isDesktopResolution || !mobileSize ? size : mobileSize;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().typography), className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[actualSize], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().boldText), isBold));
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        Tag: Tag,
        children: children,
        classes: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest);
};


/***/ }),

/***/ 62299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Header_DropDownMenu; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/sections/Header/SubMenuItem/index.jsx
var SubMenuItem = __webpack_require__(12256);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
;// CONCATENATED MODULE: ./UI/sections/Header/DropDownMenu/useDropDownMenu.js

var useDropDownMenu = function(param) {
    var isLightTheme = param.isLightTheme, isDropMenuOpened = param.isDropMenuOpened, isPageScrolledDown = param.isPageScrolledDown, slug = param.slug, closeMobileMenu = param.closeMobileMenu, closeDropDownMenu = param.closeDropDownMenu;
    var subNavigationLinks = constants/* SUB_NAVIGATION_LINKS */.qb[slug] || [];
    var handleOnLinkClick = function(subMenuLinkSlug) {
        return function() {
            if (subMenuLinkSlug) {
                closeMobileMenu();
                closeDropDownMenu();
            }
        };
    };
    return {
        slug: slug,
        isLightTheme: isLightTheme,
        isDropMenuOpened: isDropMenuOpened,
        isPageScrolledDown: isPageScrolledDown,
        handleOnLinkClick: handleOnLinkClick,
        subNavigationLinks: subNavigationLinks,
        closeMobileMenu: closeMobileMenu
    };
};

// EXTERNAL MODULE: ./UI/sections/Header/DropDownMenu/styles.module.scss
var styles_module = __webpack_require__(34901);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/Header/DropDownMenu/index.jsx









var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var DropDownMenu = function(props) {
    var ref = useDropDownMenu(props), slug = ref.slug, isLightTheme = ref.isLightTheme, isDropMenuOpened = ref.isDropMenuOpened, isPageScrolledDown = ref.isPageScrolledDown, handleOnLinkClick = ref.handleOnLinkClick, subNavigationLinks = ref.subNavigationLinks, closeMobileMenu = ref.closeMobileMenu;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((styles_module_default()).dropDownMenu, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (styles_module_default()).lightTheme, isLightTheme), (0,_define_property/* default */.Z)(_obj, (styles_module_default()).pageScrolling, isPageScrolledDown), (0,_define_property/* default */.Z)(_obj, (styles_module_default()).closed, !isDropMenuOpened), _obj)),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((styles_module_default()).dropDownLinksContainer, (styles_module_default())[slug]),
            children: subNavigationLinks === null || subNavigationLinks === void 0 ? void 0 : subNavigationLinks.map(function(param) {
                var title = param.title, path = param.path, icon = param.icon, items = param.items, marked = param.marked;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, {
                    type: constants/* ANIMATED_TYPE.isFade */.BK.isFade,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubMenuItem/* default */.Z, {
                        isLightTheme: isLightTheme,
                        isPageScrolledDown: isPageScrolledDown,
                        closeMobileMenu: closeMobileMenu,
                        handleOnClick: handleOnLinkClick,
                        activeSubMenu: slug,
                        title: title,
                        path: path,
                        icon: icon,
                        items: items,
                        slug: slug,
                        marked: marked
                    })
                }, "".concat(slug, "/").concat(title));
            })
        })
    });
};
DropDownMenu.defaultProps = {
    closeMobileMenu: function() {},
    closeDropDownMenu: function() {}
};
DropDownMenu.propTypes = {
    isDropMenuOpened: (prop_types_default()).bool.isRequired,
    isPageScrolledDown: (prop_types_default()).bool.isRequired,
    slug: (prop_types_default()).string.isRequired,
    closeMobileMenu: (prop_types_default()).func,
    closeDropDownMenu: (prop_types_default()).func
};
/* harmony default export */ var Header_DropDownMenu = (DropDownMenu);


/***/ }),

/***/ 12256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_Common_LinkWrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40659);
/* harmony import */ var UI_components_Svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6778);
/* harmony import */ var UI_components_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59654);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87055);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);








var SubMenuItem = function(param) {
    var handleOnClick = param.handleOnClick, isLightTheme = param.isLightTheme, isPageScrolledDown = param.isPageScrolledDown, closeMobileMenu = param.closeMobileMenu, title = param.title, path = param.path, icon = param.icon, items = param.items, slug = param.slug, marked = param.marked;
    var _obj;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().container), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[slug], (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().lightTheme), isLightTheme), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().pageScrolling), isPageScrolledDown), _obj)),
        onClick: handleOnClick,
        role: "button",
        tabIndex: "0",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().mainWrapper), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().marked), marked)),
                children: [
                    icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Svg__WEBPACK_IMPORTED_MODULE_4__["default"], {
                        type: icon,
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().icon)
                    }),
                    path ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Common_LinkWrapper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        isLocalLink: true,
                        path: path,
                        onClick: closeMobileMenu,
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().link),
                        children: title
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_6__["default"], {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
                        children: title
                    })
                ]
            }),
            !!(items === null || items === void 0 ? void 0 : items.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemsWrapper)),
                children: items.map(function(param) {
                    var itemPath = param.path, itemTitle = param.title, itemIcon = param.icon;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemWrapper),
                        children: [
                            itemIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Svg__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                type: itemIcon,
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemIcon)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Common_LinkWrapper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                isLocalLink: true,
                                path: itemPath,
                                onClick: closeMobileMenu,
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemLink),
                                children: itemTitle
                            })
                        ]
                    }, itemPath);
                })
            })
        ]
    });
};
SubMenuItem.defaultProps = {
    path: ""
};
SubMenuItem.propTypes = {
    handleOnClick: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func.isRequired),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string.isRequired),
    path: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (SubMenuItem);


/***/ }),

/***/ 19341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ selectIsSmallTablet; },
/* harmony export */   "Tr": function() { return /* binding */ selectIsPageReadyToDisplay; },
/* harmony export */   "Y6": function() { return /* binding */ selectIsDesktop; },
/* harmony export */   "aT": function() { return /* binding */ selectIsTablet; },
/* harmony export */   "cF": function() { return /* binding */ selectIsFirstPageLoaded; },
/* harmony export */   "eD": function() { return /* binding */ selectIsMobile; },
/* harmony export */   "qL": function() { return /* binding */ selectIsMobileCategotiesOpened; }
/* harmony export */ });
var selectIsMobileCategotiesOpened = function(state) {
    return state.layout.isMobileCategotiesOpened;
};
var selectIsPageReadyToDisplay = function(state) {
    return state.layout.isPageReadyToDisplay;
};
var selectIsFirstPageLoaded = function(state) {
    return state.layout.isFirstPageLoaded;
};
var selectIsMobile = function(state) {
    return state.layout.isMobileResolution;
};
var selectIsTablet = function(state) {
    return state.layout.isTabletResolution;
};
var selectIsSmallTablet = function(state) {
    return state.layout.isSmallTabletResolution;
};
var selectIsDesktop = function(state) {
    return state.layout.isDesktopResolution;
};


/***/ }),

/***/ 34461:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boldText":"styles_boldText__iI9uz","headline-xl":"styles_headline-xl__HRBMS","headline-l":"styles_headline-l__Veh_x","headline-m":"styles_headline-m__gfh2N","headline-s":"styles_headline-s___kodX","headline-xs":"styles_headline-xs__XhN56","paragrapgh-m":"styles_paragrapgh-m__QFKni","paragrapgh-s":"styles_paragrapgh-s__4Eq1X","caption":"styles_caption__y7HHJ"};

/***/ }),

/***/ 34901:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropDownMenu":"styles_dropDownMenu__PU95V","dropDownItemsContainer":"styles_dropDownItemsContainer__k_FKG","subMenuItem":"styles_subMenuItem__VEfnB","subMenuItemActive":"styles_subMenuItemActive__IMyHe","pageScrolling":"styles_pageScrolling__WXsyi","dropDownLinksContainer":"styles_dropDownLinksContainer__oKVlV","closed":"styles_closed__tV4Hv","lightTheme":"styles_lightTheme__VkXTK"};

/***/ }),

/***/ 87055:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__IYczC","mainWrapper":"styles_mainWrapper__miKCO","marked":"styles_marked__fb8OU","link":"styles_link__4EpNS","itemsWrapper":"styles_itemsWrapper__Kezfz","itemWrapper":"styles_itemWrapper__c1_yu","title":"styles_title__QeSx7","itemLink":"styles_itemLink__mWOpa","icon":"styles_icon__SEMNk","itemIcon":"styles_itemIcon__XayJ7","pageScrolling":"styles_pageScrolling__SQ96f","lightTheme":"styles_lightTheme__9RraG","about-company":"styles_about-company__GzgCv","solutions":"styles_solutions__QUbXy","services":"styles_services__HhLDi"};

/***/ })

}]);